export enum TransactionTypes {
    MarketBorrow = "Borrow",
    MarketLend = "Lend",
    MarketLendExternalYield = "Lend External Yield",
    Refinance = "Refinance",
    BorrowMore = "Borrow More",
    Repay = "Repay",
    Topup = "Topup",
    LoanWithdraw = "Withdraw",
    StrategyDeposit = "Strategy Deposit",
    StrategyWithdraw = "Strategy Withdraw",
    EarnBorrow = "Earn Borrow",

    Generic = "Generic", // Generic transaction type for when no specific transaction type is available
    LoopUnwind = "Loop Unwind",
    VaultDeposit = "Vault Deposit",
    VaultWithdraw = "Vault Withdraw"
}
